import { render, staticRenderFns } from "./Ber.vue?vue&type=template&id=b58aa2b2"
import script from "./Ber.vue?vue&type=script&lang=js"
export * from "./Ber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports